import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/shadcn/select";
import { Show } from "solid-js";

export const ListSummary = (props) => {

  const onChange = (item) => {
    props.onChange(item);
  }

  const summary = () => {
    if (props.pagination.totalRows === 0) {
      return "No record found.";
    }

    if (props.pagination.totalRows === 1) {
      return "Showing 1 record.";
    }

    const firstRecord = props.pagination.perPage * (props.pagination.currentPage - 1) + 1;
    const lastRecord = Math.min(props.pagination.perPage * props.pagination.currentPage, props.pagination.totalRows);

    return `Showing ${firstRecord}-${lastRecord} of ${props.pagination.totalRows} records.`;
  }

  return (
    <div class="flex items-center space-x-2">
      <Show when={props.pagination.changePerPage}>
        <p class="whitespace-nowrap text-sm font-medium">Records per page</p>
        <Select
          value={props.pagination.perPage}
          onChange={onChange}
          options={props.pagination.options}
          itemComponent={itemProps => <SelectItem item={itemProps.item}>{itemProps.item.rawValue}</SelectItem>}
        >
          <SelectTrigger class="h-8">
            <SelectValue class="me-2">{state => state.selectedOption()}</SelectValue>
          </SelectTrigger>
          <SelectContent />
        </Select>
      </Show>
      <div class="flex-1 whitespace-nowrap text-sm text-muted-foreground">
        {summary()}
      </div>
    </div>
  );
}
